import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from '../../../../AppRoutes';
import { Icon } from '../../../../components';

export interface ITransactionWraperProps {}

export const transactionWrapper =
  (Component: FC<ITransactionWraperProps>) =>
  (props: ITransactionWraperProps) => {
    return (
      <div className='withTransactionWraper'>
        <div className='TabLinks'>
          <NavLink to={Routes.transactionList.path}>
            <Icon.Transaction2Icon />
            Transactions
          </NavLink>

          {/* <NavLink to={Routes.placeGameList.path} >
                        <Icon.PlaceGameIcon />
                        Place Game
                    </NavLink>

                    <NavLink to={Routes.withdraw.path} >
                        <Icon.KYC />
                        Withdraw Progress
                    </NavLink> */}
        </div>

        <Component {...props} />
      </div>
    );
  };
